<aside class="al-sidebar" sidebarResize>
    <ba-menu [menuHeight]="menuHeight" [sidebarCollapsed]="isMenuCollapsed" (expandMenu)="menuExpand()"></ba-menu>
    <!-- <language-switcher [sidebarCollapsed]="isMenuCollapsed"></language-switcher> -->
</aside>
